import { render, staticRenderFns } from "./history-payment.vue?vue&type=template&id=2a6d5e96&"
import script from "./history-payment.vue?vue&type=script&lang=js&"
export * from "./history-payment.vue?vue&type=script&lang=js&"
import style0 from "./history-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports